import post_collection from "../partials/post_collection";
import links, { link } from "./links";
import hidden from "./hidden";
import picture from "./picture";

const opt_link = link("Optional Link", "opt_lnk");

const page_title = {
  label: "Page Title",
  name: "page_title",
  widget: "string",
  required: true,
};

const page = (name, label, max, min) => ({
  label,
  name,
  widget: "object",
  fields: [
    page_title,
    {
      widget: "list",
      field: post_collection,
      allow_add: true,
      name: "posts",
      label: "Select Posts or Pages",
      max,
      min,
    },
    opt_link,
    hidden("arrangement"),
    hidden("em"),
    hidden("para"),
  ],
});

export const page_of_three = (name = "3items") =>
  page(name, "Page of 3 Elements", 3, 3);

export const page_of_four = (name = "4items") =>
  page(name, "Page of 4 Elements", 4, 4);

export const page_of_cheques = (name = "4chequed") =>
  page(name, "Page of 4 Elements (Chequed)", 4, 4);

export const page_of_recent = (name = "recent") => ({
  label: "Recent Posts",
  name,
  widget: "object",
  fields: [
    page_title,
    {
      label: "Arrangement of Articles?",
      name: "arrangement",
      widget: "select",
      options: [
        {
          label: "3 Vertical",
          value: "3V",
        },
        {
          label: "4 Staggered",
          value: "4S",
        },
        {
          label: "4 Chequered",
          value: "4C",
        },
      ],
    },
    opt_link,
    hidden("posts"),
  ],
});

export const hero_content = [
  {
    label: "Tag Line?",
    name: "tag",
    widget: "text",
    required: false,
  },
  {
    label: "Main Header?",
    name: "main",
    widget: "boolean",
    default: false,
  },
  {
    label: "Parallax?",
    name: "parallax",
    widget: "boolean",
    default: false,
  },
  picture("bgimage", "Background Image"),
  {
    label: "Content on left or right?",
    name: "arrangement",
    widget: "select",
    default: "left",
    options: [
      {
        label: "Left",
        value: "left",
      },
      {
        label: "Right",
        value: "right",
      },
    ],
  },
  {
    label: "Emphasised Content",
    name: "em",
    widget: "text",
    required: false,
  },
  {
    label: "Normal Content",
    name: "para",
    widget: "text",
    required: false,
  },
  hidden("posts"),
];

export const page_of_hero = (name = "hero") => ({
  label: "Hero Style",
  name,
  widget: "object",
  fields: [
    page_title,
    {
      label: "Content Title",
      name: "title",
      widget: "string",
      required: true,
    },
    ...hero_content,
    links("Call To Action", "links", 0, 2),
  ],
});

export const item = {
  label: "Item",
  name: "item",
  widget: "object",
  fields: [
    { label: "Figure", name: "figure", widget: "string", required: true },
    {
      label: "Small Figures",
      name: "small",
      widget: "string",
      required: false,
    },
    {
      label: "Description",
      name: "description",
      widget: "string",
      required: true,
    },
  ],
};

export const grid_of_facts = (name = "facts") => ({
  label: "Grid of Facts",
  name,
  widget: "object",
  fields: [
    page_title,
    {
      name: "items",
      label: "Grid Items",
      widget: "list",
      fields: [item],
      max: 6,
      min: 6,
    },
  ],
});
